import {
  BasicOverlay,
  BasicOverlayData,
} from "$/game/prefabs/scenes/overlays/BasicOverlay.ts";
import { SoundManagerGlobalPlugin } from "$/game/plugins/SoundManagerGlobalPlugin.ts";

export class MainSettingsOverlay extends BasicOverlay {
  private soundManager!: SoundManagerGlobalPlugin;

  constructor() {
    super({ key: "MainSettingsOverlay" });
  }

  override init() {
    super.init();
    this.soundManager = this.plugins.get(
      "soundManager",
    ) as SoundManagerGlobalPlugin;
  }

  override create(data: BasicOverlayData) {
    super.create(data);

    const centerX = this.cameras.main.width / 2;
    const startY = 200;
    const spacing = 120;

    const title = this.add.text(centerX, startY, this.keys.strings.settings, {
      fontSize: "48px",
      color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      fontFamily: "Phantom-Muff",
    });
    title.setOrigin(0.5);

    this.createMusicToggle(centerX, startY + spacing);
    this.createSoundToggle(centerX, startY + spacing * 2);
  }

  private createMusicToggle(x: number, y: number) {
    this.add.text(x - 150, y, this.keys.strings.settingsOverlay.music, {
      fontSize: "32px",
      color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      fontFamily: "Phantom-Muff",
    }).setOrigin(0, 0.5);

    const isMusicEnabled = this.settings.getSetting("isMusicEnabled");
    const toggleBg = this.add.rectangle(
      x + 100,
      y,
      80,
      40,
      isMusicEnabled ? this.global.TUNER_TWA_CONFIG.palette.success : 0x666666,
      1,
    )
      .setInteractive()
      .on("pointerdown", () => {
        if (this.settings.getSetting("isVibrationEnabled")) {
          this.telegram.twaSDK.hapticFeedback.selectionChanged();
        }
        const newValue = !this.settings.getSetting("isMusicEnabled");
        this.settings.setSetting("isMusicEnabled", newValue);
        toggleBg.setFillStyle(
          newValue ? this.global.TUNER_TWA_CONFIG.palette.success : 0x666666,
        );
        toggleKnob.setX(x + 100 + (newValue ? 20 : -20));

        if (newValue) {
          const pet = this.registry.get("pet");
          if (pet?.is_alive) {
            this.soundManager.playMusic(this.keys.assets.sounds.music.home);
          }
        } else {
          this.soundManager.stopMusic();
        }
      });

    const toggleKnob = this.add.circle(
      x + 100 + (isMusicEnabled ? 20 : -20),
      y,
      15,
      0xffffff,
    );
  }

  private createSoundToggle(x: number, y: number) {
    this.add.text(x - 150, y, this.keys.strings.settingsOverlay.sound, {
      fontSize: "32px",
      color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      fontFamily: "Phantom-Muff",
    }).setOrigin(0, 0.5);

    const isSoundEnabled = this.settings.getSetting("isSoundEnabled");
    const toggleBg = this.add.rectangle(
      x + 100,
      y,
      80,
      40,
      isSoundEnabled ? this.global.TUNER_TWA_CONFIG.palette.success : 0x666666,
      1,
    )
      .setInteractive()
      .on("pointerdown", () => {
        if (this.settings.getSetting("isVibrationEnabled")) {
          this.telegram.twaSDK.hapticFeedback.selectionChanged();
        }
        const newValue = !this.settings.getSetting("isSoundEnabled");
        this.settings.setSetting("isSoundEnabled", newValue);
        toggleBg.setFillStyle(
          newValue ? this.global.TUNER_TWA_CONFIG.palette.success : 0x666666,
        );
        toggleKnob.setX(x + 100 + (newValue ? 20 : -20));

        // Sound effects are controlled by the isSoundEnabled setting
        // The SoundManagerGlobalPlugin checks this setting in playSound method
      });

    const toggleKnob = this.add.circle(
      x + 100 + (isSoundEnabled ? 20 : -20),
      y,
      15,
      0xffffff,
    );
  }
}
